import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-12 md:grid-cols-8 grid-cols-1 gap-4 w-full items-center py-4 my-0" }
const _hoisted_2 = { class: "md:col-span-1 col-span-6 flex flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "ID:", -1)
const _hoisted_4 = { class: "md:col-span-3 col-span-12 flex flex-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Local:", -1)
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = { class: "md:col-span-2 col-span-6 flex flex-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Início:", -1)
const _hoisted_9 = { class: "md:col-span-2 col-span-6 flex flex-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Final:", -1)
const _hoisted_11 = { class: "md:col-span-2 col-span-12 flex flex-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Responsável:", -1)
const _hoisted_13 = { class: "md:col-span-2 col-span-12 flex flex-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Data:", -1)

import UserDisplay from '../AvatarUser/index.vue'
import { MappedDomainPolicy } from '@/types/domain'

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'TableDomainDsPolicies',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("p", null, _toDisplayString(_ctx.data.id), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.data.local), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("p", null, _toDisplayString(_ctx.data.startDate), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("p", null, _toDisplayString(_ctx.data.endDate), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(UserDisplay, {
          name: _ctx.data.responsavel
        }, null, 8, ["name"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("p", null, _toDisplayString(_ctx.data.vinculoDate), 1)
      ])
    ])
  ]))
}
}

})